module.exports = __webpack_public_path__ + "static/img/screen_init_header.f57793f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/screen_init_header.png
// module id = JuIj
// module chunks = 1